'use client';

import React, { useEffect, useState } from 'react';
import { twMerge } from 'utilities/src/twMerge';
import useFooterThemes from './themes';

const extraDocs = [
  {
    name: 'Privacy Policy',
    link: 'https://www.bairesdev.com/privacy-policy/',
    className: 'hover:underline',
  },
  {
    name: 'Terms of Service',
    link: 'https://www.bairesdev.com/terms-conditions/',
    className: 'hover:underline',
  },
  {
    name: 'Do Not Sell My Personal Information',
    link: 'https://www.bairesdev.com/do-not-sell-my-personal-information/',
    className: 'hover:underline',
  },
];

export interface LegalCopyRightProps {
  yearData?: number;
  customContainerClasses?: string;
}

export default function LegalCopyRight({ yearData, customContainerClasses }: LegalCopyRightProps) {
  const [showYear, setShowYear] = useState(yearData);
  useEffect(() => {
    if (!yearData) {
      const fetchData = async () => {
        const data = await fetch(`${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}/api/year`);
        const { year } = await data.json();
        setShowYear(year);
      };

      fetchData();
    }
  }, []);

  const { footerLinksContainerClasses, footerLinksClasses, footerLegalClasses } = useFooterThemes();

  return (
    <section className={twMerge(footerLinksContainerClasses, customContainerClasses)}>
      <div className={twMerge(footerLinksClasses)}>
        {extraDocs.map((el, key) => (
          <React.Fragment key={el.name}>
            <a href={el.link} target="_blank" rel="noreferrer" className={el.className}>
              {el.name}
            </a>
            <span className={`mx-2 ${extraDocs.length === key + 1 ? 'hidden' : ''}`}>|</span>
          </React.Fragment>
        ))}
      </div>
      <div className={twMerge(footerLegalClasses)}>
        <p>BairesDev 2009 - {showYear}. All rights reserved.</p>
      </div>
    </section>
  );
}
